/*
 * NUHO Product Page — Selling Plan Interceptor
 *
 * Instead of fighting Appstle for click handlers,
 * we intercept fetch() itself. When ANY code calls /cart/add.js
 * for our product without a selling_plan, we inject it.
 *
 * This works regardless of who triggers the add-to-cart.
 */
(function() {
  if (!window.location.pathname.includes('/products/')) return;

  var KNOWN_VARIANT = 56178029953410;
  var KNOWN_SELLING_PLAN = 710858801538;
  var isSubscribeMode = true; // default

  // Event delegation on document — works regardless of when Appstle renders buttons
  // (fixes incognito race condition where buttons load AFTER DOMContentLoaded)
  document.addEventListener('click', function(e) {
    var opt = e.target.closest('[data-opt]');
    if (!opt) return;
    isSubscribeMode = (opt.getAttribute('data-opt') === 'subscribe');
    console.log('NUHO: mode =', isSubscribeMode ? 'subscribe' : 'onetime');
  });

  // Monkey-patch fetch to intercept /cart/add.js
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && options && options.body) {
      try {
        var body = JSON.parse(options.body);
        if (body.items && Array.isArray(body.items)) {
          var modified = false;
          body.items.forEach(function(item) {
            if (item.id === KNOWN_VARIANT && !item.selling_plan && isSubscribeMode) {
              item.selling_plan = KNOWN_SELLING_PLAN;
              modified = true;
            }
          });
          if (modified) {
            console.log('NUHO: injected selling_plan into cart/add request', body);
            options = Object.assign({}, options, {
              body: JSON.stringify(body)
            });
          }
        }
      } catch(e) {
        // Not JSON, probably FormData — try that too
      }
    }

    // Also intercept FormData-based requests
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && options && options.body instanceof FormData) {
      var fd = options.body;
      var variantId = parseInt(fd.get('id'), 10);
      var currentSp = fd.get('selling_plan');
      if (variantId === KNOWN_VARIANT && (!currentSp || currentSp === '' || currentSp === '0') && isSubscribeMode) {
        fd.set('selling_plan', String(KNOWN_SELLING_PLAN));
        console.log('NUHO: injected selling_plan into FormData request');
      }
    }

    return originalFetch.call(this, url, options);
  };

  // Also monkey-patch XMLHttpRequest for older code paths
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._nuhoUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (this._nuhoUrl && this._nuhoUrl.indexOf('/cart/add') !== -1 && typeof body === 'string') {
      try {
        var data = JSON.parse(body);
        if (data.id === KNOWN_VARIANT && !data.selling_plan && isSubscribeMode) {
          data.selling_plan = KNOWN_SELLING_PLAN;
          body = JSON.stringify(data);
          console.log('NUHO: injected selling_plan into XHR request');
        }
        if (data.items) {
          data.items.forEach(function(item) {
            if (item.id === KNOWN_VARIANT && !item.selling_plan && isSubscribeMode) {
              item.selling_plan = KNOWN_SELLING_PLAN;
              console.log('NUHO: injected selling_plan into XHR items request');
            }
          });
          body = JSON.stringify(data);
        }
      } catch(e) {}
    }
    return origXHRSend.call(this, body);
  };

  console.log('NUHO: selling plan interceptor loaded v2 (event delegation, fixes incognito race)');
})();

/* NUHO-OFFER-PRESELECT v2 : ad/Meta traffic -> persist flag (survives home->product nav) -> preselect 67.- */
(function(){
  try{
    var p=new URLSearchParams(window.location.search);
    if(p.get('offer')==='onetime'||p.get('utm_source')==='meta'){
      try{ localStorage.setItem('nuho_meta_offer', String(Date.now())); }catch(e){}
    }
  }catch(e){}
  function metaFlag(){
    try{
      var p=new URLSearchParams(window.location.search);
      if(p.get('offer')==='onetime'||p.get('utm_source')==='meta') return true;
      var t=parseInt(localStorage.getItem('nuho_meta_offer')||'0',10);
      // flag valable 2h
      if(t && (Date.now()-t) < 7200000) return true;
    }catch(e){}
    return false;
  }
  function apply(){
    if(!metaFlag()) return false;
    var one=document.querySelector('.pdp__opt[data-opt="onetime"]');
    if(one && !one.classList.contains('pdp__opt--active')){ one.click(); return true; }
    return false;
  }
  window.addEventListener('load',apply);
  var n=0,iv=setInterval(function(){ n++; if(apply()||n>30) clearInterval(iv); },200);
})();
